import { Link, LinkProps } from 'react-router-dom';
import styled from 'styled-components';

const linkColors = {
  primary: {
    default: '#007bff',
    hover: '#0056b3',
  },
  black: {
    default: '#000000',
    hover: '#000088',
  },
};

export type LinkVariant = keyof typeof linkColors;

export interface AppLinkProps extends LinkProps {
  variant?: LinkVariant;
  bold?: boolean;
  block?: boolean;
}

interface StyledLinkProps {
  variant: LinkVariant;
  $bold?: boolean;
  $block?: boolean;
}

const StyledLink = styled(Link)<StyledLinkProps>`
  text-decoration: none;
  cursor: pointer;
  color: ${({ variant }) => linkColors[variant].default};

  &:hover {
    color: ${({ variant }) => linkColors[variant].hover};
  }

  &:focus-visible {
    outline: 2px solid rgba(0, 123, 255, 0.4);
    outline-offset: 2px;
  }

  ${({ $bold }) => $bold && 'font-weight: 600;'}
  ${({ $block }) => $block && 'display: block;'}
`;

const AppLink = ({ to, children, variant = 'primary', bold = false, block = false, ...rest }: AppLinkProps) => {
  return (
    <StyledLink to={to} variant={variant} $bold={bold} $block={block} {...rest}>
      {children}
    </StyledLink>
  );
};

export default AppLink;
